import { getFileName } from '@jbrowse/core/util/tracks';
export default function GuessNCListF(pluginManager) {
    pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', (adapterGuesser) => {
        return (file, index, adapterHint) => {
            const regexGuess = /trackData.jsonz?$/i;
            const adapterName = 'NCListAdapter';
            const fileName = getFileName(file);
            if (regexGuess.test(fileName) || adapterHint === adapterName) {
                return {
                    type: adapterName,
                    rootUrlTemplate: file,
                };
            }
            return adapterGuesser(file, index, adapterHint);
        };
    });
}
